<app-content-body class="h-100 px-2 content-body" style="margin-top: 60px;">

  <div class="container-fluid py-1">

    <app-content-heading
    [title]="'Environment ('+environment.environmentName + ')'"
    [icon]="faHome"
    [hasBreadcrumbs]="true"
  ></app-content-heading>

    <div class="col-12">
      <div class="card ">
        <div class="card-header bg-light fw-bold d-flex flex-row justify-content-between align-items-center">
          <h6 >
            Overview
          </h6>
          <div class="d-flex flex-row gap-2">
            <button
              (click)="this.redirectToPeering(ConnectionTypeEnum.PRIVATE_LINK)"
              routerLinkActive="router-link-active"
              class="btn btn-sm btn-primary rounded-1 px-3"
              *ngIf="false"
            >
            Private Link
            </button>
            <button
              (click)="redirectToPeering(ConnectionTypeEnum.PEERING)"
              routerLinkActive="router-link-active"
              class="btn btn-sm btn-primary rounded-1 px-3"
              *ngIf="!isPublicIpEnabled()"
            >
            {{ isAWS() ? 'VPC' : 'VNET' }} Peering
            </button>
            <button
              routerLinkActive="router-link-active"
              (click)="navigateToPeeringPage()"
              class="btn btn-sm btn-primary rounded-1"
              *ngIf="false"
            >
              <fa-icon class="me-1" [icon]="faNetworkWired"></fa-icon>
              Setup WAN Replication
            </button>
            <button
              *ngIf="
                environmentInfo?.removalDate &&
                environmentInfo?.removalDate !== ''
              "
              class="btn btn-sm btn-outline-primary"
            >
              <i class="fa fa-refresh me-2"></i>
              Restore Environment
            </button>
          </div>
        </div>
        <div class="card-body">
          <div class="row row-cols-2">


          <div class="col" *ngIf="environment" >
            <ul class="list-group list-group-flush">

              <li class="list-group-item d-flex justify-content-between align-items-start ps-2">
                <div class="me-auto">
                  <div class="fw-bold">Environment Type:</div>
                  <span class="text-muted small"></span>
                </div>
                <span class="">{{ environment.environmentType }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-start ps-2">
                <div class="me-auto">
                  <div class="fw-bold">Region:</div>
                  <span class="text-muted small"></span>
                </div>
                <span class="">{{ environment.regionDisplayName }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-start ps-2">
                <div class="me-auto">
                  <div class="fw-bold">Server Plan:</div>
                  <span class="text-muted small"></span>
                </div>
                <span class="">{{ environment.serverPlan }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-start ps-2">
                <div class="me-auto">
                  <div class="fw-bold">NCache Version:</div>
                  <span class="text-muted small"></span>
                </div>
                <span class="">{{ environment.nCacheVersion }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-center ps-2 mt-1">
                <div class="me-auto">
                  <div class="fw-bold">Connection Type:</div>
                  <span class="text-muted small"></span>
                </div>
                <span class="">{{ getConnectionType() }}
                  <a [href]="ncacheConnectCachePublicIPLink" target="ncentclawsy"  *ngIf="isPublicIpEnabled()">(How to connect to NCache over public IP?)</a>
                </span>
              </li>
              <li class="list-group-item d-flex justify-content-between align-items-start ps-2" *ngIf="!this.isPAYG() && isPublicIpEnabled()">
                <div class="me-auto">
                  <div class="fw-bold">Reserved Capacity:</div>
                  <span class="text-muted small"></span>
                </div>
                <span class="">{{ environment.reservedCapacity }}
                </span>
              </li>
              </ul>
            </div>
            <div class="col">
              <ul class="list-group list-group-flush">

                <li class="list-group-item d-flex justify-content-between align-items-start ps-2">
                  <div class="me-auto">
                    <div class="fw-bold">CIDR Block:</div>
                    <span class="text-muted small"></span>
                  </div>
                  <span class="">{{ environment.networkCidr }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-start ps-2">
                  <div class="me-auto">
                    <div class="fw-bold">Cloud Provider:</div>
                    <span class="text-muted small"></span>
                  </div>
                  <span class=""> {{ environment.cloudVendor }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-start ps-2">
                  <div class="me-auto">
                    <div class="fw-bold">Availability Zone:</div>
                    <span class="text-muted small"></span>
                  </div>
                  <span class="">  {{ getAvailabilityZone() }}</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center ps-2">
                  <div class="me-auto">
                    <div class="fw-bold">{{ isAWS() ? 'VPC' : 'Resource Group' }}:</div>
                    <span class="text-muted small"></span>
                  </div>
                  <span class=""> {{ getResource() }}
                    <app-clipboard-copy [textToCopy]="getResource()" /></span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-start ps-2" *ngIf="isPublicIpEnabled()">
                  <div class="me-auto">
                    <div class="fw-bold">Allowed IP Addresses:</div>
                    <span class="text-muted small"></span>
                  </div>
                  <span class="">
                    <a class="link-opacity-100" href="javascript:void(0)" (click)="openConfigureIPsModal()">Edit</a>
                  </span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-start ps-2" *ngIf="!this.isPAYG() && !isPublicIpEnabled()">
                  <div class="me-auto">
                    <div class="fw-bold">Reserved Capacity:</div>
                    <span class="text-muted small"></span>
                  </div>
                  <span class="">{{ environment.reservedCapacity }}
                  </span>
                </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
        <div class="card-body px-5 py-4" *ngIf="!isHosted">
          <div
            *ngIf="environment == undefined"
            class="loader"
          ></div>
          <div *ngIf="environment">
            <div class="row mb-2">
              <div class="col-sm-3">Environment Type:</div>
              <div class="col-sm-3">
                {{ environment.environmentType }}
              </div>
              <div class="col-sm-3">License Type:</div>
              <div class="col-sm-3">
                {{ nonHostedEnvironmentInfo.environmentInfo.licenseType }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-sm-3">Server Licenses:</div>
              <div class="col-sm-3">
                {{ nonHostedEnvironmentInfo.environmentInfo.serverLicenses }}
              </div>
              <div class="col-sm-3">Client Licenses:</div>
              <div class="col-sm-3">
                {{ nonHostedEnvironmentInfo.environmentInfo.clientLicenses }}
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-sm-3">Server Licenses Available:</div>
              <div class="col-sm-3">
                {{
                  nonHostedEnvironmentInfo.environmentInfo
                    .serverLicensesAvailable
                }}
              </div>
              <div class="col-sm-3">Client Licenses Available:</div>
              <div class="col-sm-3">
                {{
                  nonHostedEnvironmentInfo.environmentInfo
                    .clientLicensesAvailable
                }}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  <div class="d-flex flex-row mt-5 flex-1">

    <div class="col-sm-12">

      <div class="card card-height rounded-0">

        <div class="card-header bg-light fw-bold d-flex flex-row justify-content-between align-items-center">

          <div class="d-flex justify-content-between align-items-center mb-2">

            <!-- TABS -->

            <ul class="nav nav-tabs" id="myTab" role="tablist">

              <li class="nav-item" role="presentation">

                <button
                  class="nav-link active"
                  id="servers-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#servers"
                  type="button"
                  role="tab"
                  aria-controls="servers"
                  aria-selected="true"
                  (click)="this.setActiveTab(EnvironmentTabEnum.SERVERS)">
                  Servers
                </button>

              </li>

              <li class="nav-item" role="presentation">

                <button
                  class="nav-link"
                  id="vnet-peerings-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#vnet-peerings"
                  type="button"
                  role="tab"
                  aria-controls="vnet-peerings"
                  aria-selected="false"
                  *ngIf="!isPublicIpEnabled()"
                  (click)="this.setActiveTab(EnvironmentTabEnum.PEERINGS)">
                  {{ isAWS() ? 'VPC' : 'VNET' }} Peering
                </button>

              </li>

              <!-- <li class="nav-item" role="presentation">

                <button
                  class="nav-link"
                  id="private-links-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#private-links"
                  type="button"
                  role="tab"
                  aria-controls="private-links"
                  aria-selected="false"
                  (click)="this.setActiveTab(EnvironmentTabEnum.PRIVATE_LINKS)">
                  Private Links
                </button>

              </li> -->

            </ul>
            </div>

            <!-- TABS END -->


				<div class="d-flex flex-row align-items-center" *ngIf="isHosted">

            <button *ngIf="this.isActiveTab(EnvironmentTabEnum.SERVERS)" routerLinkActive="router-link-active"
					    (click)="guide('clusterinfo')"
              class="btn btn-outline-primary me-2"
              >
					    Cluster Info
				      </button>


              <button
              *ngIf="this.isActiveTab(EnvironmentTabEnum.SERVERS)"
              routerLinkActive="router-link-active"
              (click)="guide('powershell')"
              class="btn btn-outline-primary me-2 d-none"
              >
              Power Shell
            </button>

            <button
              *ngIf="this.isActiveTab(EnvironmentTabEnum.SERVERS)"
              routerLinkActive="router-link-active"
              (click)="guide('remoteclient')"
              class="btn btn-outline-primary me-2"
              >
              Remote Client
            </button>


              <button
                *ngIf="this.isActiveTab(EnvironmentTabEnum.SERVERS)"
                routerLinkActive="router-link-active"
                (click)="navigateToAddServersPage()"
                class="btn btn-outline-primary me-2"
              >
                <fa-icon class="me-1" [icon]="faPlus"></fa-icon>
                Add Server
              </button>


              <button
                routerLinkActive="router-link-active"
                (click)="refresh()"
                class="btn btn-outline-success me-2"
                >
                <fa-icon class="me-1" [icon]="faRotateRight"></fa-icon>
              </button>

              <button
              *ngIf="!checkForRestoration() && this.isActiveTab(EnvironmentTabEnum.SERVERS)"
              routerLinkActive="router-link-active"
              [disabled]="disableButtons"
              class="btn btn-outline-danger"
              (click)="openDeleteServerModal()"
              [ngClass]="{
                'text-secondary': disableButtons,
              }"
            >
              <fa-icon class="me-1" [icon]="faTrash"></fa-icon>
            </button>

            <button
                *ngIf="this.isActiveTab(EnvironmentTabEnum.PEERINGS)"
                class="btn btn-outline-danger"
                [ngClass]="{'text-secondary': !peeringSelection.hasValue() || !canDeletePeering()}"
                [disabled]="!peeringSelection.hasValue() || !canDeletePeering()"
                (click)="confirmDeletePeering()">
                <fa-icon class="me-1" [icon]="faTrash"></fa-icon>
            </button>

            </div>

          </div>



        <div class="table-parent card-body">

          <!-- Tabs Content -->
          <div class="tab-content" id="myTabContent">


            <!-- Servers Tab Content -->
            <div class="tab-pane fade show active" id="servers" role="tabpanel" aria-labelledby="servers-tab" style="margin-bottom: 5rem !important;">


              <table mat-table *ngIf="!isServersLoading" [dataSource]="servers">

                <ng-container matColumnDef="Server Name">
                  <th mat-header-cell *matHeaderCellDef>
                    <input
                      type="checkbox"
                      class="form-check-input custom-checkbox me-5"
                      (change)="$event ? toggleAllRows() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()"
                    />
                    Server Name</th>
                  <td mat-cell *matCellDef="let row">
                    <input
                    type="checkbox"
                    class="form-check-input custom-checkbox me-5"
                    (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)"
                  />
                    {{ row.name || '' }}
                  </td>

                </ng-container>

                <ng-container matColumnDef="IP Address">
                  <th mat-header-cell *matHeaderCellDef>{{isPublicIpEnabled() ? 'Private IP Address' : 'IP Address'}}</th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.privateIp || '---' }}</td>
                </ng-container>

                <ng-container matColumnDef="Public IP Address" *ngIf="isPublicIpEnabled()">
                  <th mat-header-cell *matHeaderCellDef>Public IP Address</th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.publicIp || '---' }}<app-clipboard-copy [textToCopy]="row.publicIp" /></td>
                </ng-container>

                <ng-container matColumnDef="Created At">
                  <th mat-header-cell *matHeaderCellDef>Created</th>
                  <td mat-cell *matCellDef="let row">{{ this.getReadableDate(row.createdAt) }}</td>
                </ng-container>

                <ng-container matColumnDef="Status">
                  <th mat-header-cell *matHeaderCellDef>Status</th>
                  <td mat-cell *matCellDef="let row">
                    <fa-icon class="me-1 rotating-icon"
                    [icon]="getVMStatusFromArray(row.id) === 'deleting' || getVMStatusFromArray(row.id) === 'provisioning' || getVMStatusFromArray(row.id) === 'pending' || getVMStatusFromArray(row.id) === 'starting' || getVMStatusFromArray(row.id) === 'stopping' ? faSpinner:faCircle" [ngClass]='{
                      "text-primary":getVMStatusFromArray(row.id) === "running",
                      "text-danger": getVMStatusFromArray(row.id) === "provisioning_failed" || getVMStatusFromArray(row.id) === "deletion_failed",
                      "text-secondary": getVMStatusFromArray(row.id) === "pending" || getVMStatusFromArray(row.id) === "provisioning" || getVMStatusFromArray(row.id) === "deleting" || getVMStatusFromArray(row.id) === "stopped"
                    }'></fa-icon>
                        {{ getVmTextStatus(row.id) }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="Action">
                  <th mat-header-cell *matHeaderCellDef>Action</th>
                  <td mat-cell *matCellDef="let row">
                    <button
                      [disabled]="row.retryButtonDisable"
                      *ngIf="row.status === 'provisioning_failed'"
                      class="btn btn-sm border-0 text-primary p-0"
                      (click)="triggerVMAction(row)">{{getActionButtonText(row.status)}}</button>

                    <div *ngIf="row.status === 'pending' || row.status === 'active' || row.status === 'provisioning' || row.status === 'deleting' || row.status === 'deletion_failed'" class="d-flex align-items-center">
                      <div *ngIf="row.publicIp != null ; else dashes">
                        <a *ngIf="isClusterFormationComplete(row.id)" href="javascript:void(0)" (click)="openOrFocusWindow(row.publicIp)"  class="text-decoration-none">Manage</a>
                        <span *ngIf="!isClusterFormationComplete(row.id)">
                          <fa-icon class="me-1 rotating-icon" [icon]="faSpinner"/> <span class="ms-1">Fetching Details</span>
                        </span>
                      </div>
                      <ng-template #dashes>--</ng-template>
                    </div>
                  </td>
                </ng-container>

                <tr
                  mat-header-row
                  *matHeaderRowDef="displayedColumns; sticky: true"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"
                ></tr>
              </table>

             <div class="d-flex flex-row justify-content-center align-items-center spinner-parent" *ngIf="isServersLoading">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>

              <div
                *ngIf="!isServersLoading && servers.data != undefined && servers.data.length === 0"
                class="spinner-parent d-flex flex-row justify-content-center align-items-center"
              >
                <div class="d-flex flex-row align-items-center gap-3">
                  <fa-icon [icon]="faInbox" class="fs-5"></fa-icon>
                  <p class="m-0">No Servers Found</p>
                </div>
              </div>

            </div>

            <!-- VNet Peerings Tab Content -->
            <div class="tab-pane fade" id="vnet-peerings" role="tabpanel" aria-labelledby="vnet-peerings-tab">

              <table mat-table [dataSource]="peerings.data">

                <ng-container matColumnDef="Peering ID">

                  <th mat-header-cell *matHeaderCellDef>
                    <input
                      type="checkbox"
                      class="form-check-input custom-checkbox me-5"
                      (change)="$event ? toggleAllPeeringRows() : null"
                      [checked]="peeringSelection.hasValue() && isAllPeeringsSelected()"
                      [indeterminate]="peeringSelection.hasValue() && !isAllPeeringsSelected()"
                    />

                    Peering Name

                  </th>

                  <td mat-cell *matCellDef="let row">

                    <input
                      type="checkbox"
                      class="form-check-input custom-checkbox me-5"
                      (click)="$event.stopPropagation()"
                      (change)="$event ? peeringSelection.toggle(row) : null"
                      [checked]="peeringSelection.isSelected(row)"
                    />

                    {{this.getResourceName(row.peeringId) || row.peeringName || '---'}}

                  </td>

                </ng-container>

                <ng-container matColumnDef="Account ID">
                  <th mat-header-cell *matHeaderCellDef>{{this.getAcountIDColumnName()}}</th>
                  <td mat-cell *matCellDef="let row">{{this.getAccountIDValue(row)}}</td>
                </ng-container>

                <ng-container matColumnDef="Network Resource ID">
                  <th mat-header-cell *matHeaderCellDef>VNET Name</th>
                  <td mat-cell *matCellDef="let row">{{this.getResourceName(row.networkResourceId) || '---'}}</td>
                </ng-container>

                <ng-container matColumnDef="Client Network Resource ID">
                  <th mat-header-cell *matHeaderCellDef>Client VNET Name</th>
                  <td mat-cell *matCellDef="let row">{{this.getResourceName(row.clientNetworkResourceId) || '---'}}</td>
                </ng-container>

                <ng-container matColumnDef="Client Network CIDR">
                  <th mat-header-cell *matHeaderCellDef>Client Network CIDR</th>
                  <td mat-cell *matCellDef="let row">{{ row.clientNetworkCidr || '---' }}</td>
                </ng-container>

                <ng-container matColumnDef="Region">
                  <th mat-header-cell *matHeaderCellDef>Region</th>
                  <td mat-cell *matCellDef="let row">{{ environment.regionDisplayName || '---' }}</td>
                </ng-container>

                <ng-container matColumnDef="Status">
                  <th mat-header-cell *matHeaderCellDef>Status</th>
                  <td mat-cell *matCellDef="let row">
                    <fa-icon class="me-1" [icon]="(row.status !== 'unknown' && row.status !== 'Disconnected' && row.status !== 'failed') ? faCircle : faClose" [ngClass]="(row.status !== 'unknown' && row.status !== 'Disconnected' && row.status !== 'failed') ? 'text-primary':'text-danger'"></fa-icon>
                    {{ row.status | titlecase }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="Action">

                  <th mat-header-cell *matHeaderCellDef>Action</th>

                  <td mat-cell *matCellDef="let row">

                    <div *ngIf="this.showConfigure(row.status); else noAction">
                      <button class="btn btn-primary btn-sm" (click)="this.navigateToConnectionWizard(row)">Configure</button>
                    </div>

                    <ng-template #noAction>
                      ---
                    </ng-template>

                  </td>

                </ng-container>

                <tr mat-header-row *matHeaderRowDef="peeringColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: peeringColumns" (click)="selection.toggle(row)" ></tr>

              </table>

              <div
                *ngIf="isLoadingPeerings  "
                class="spinner-parent d-flex flex-row justify-content-center align-items-center"
              >
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>

              <div
                *ngIf="!isLoadingPeerings && peerings.data != undefined && peerings.data.length === 0"
                class="spinner-parent d-flex flex-row justify-content-center align-items-center"
              >
                <div class="d-flex flex-row align-items-center gap-3">
                  <fa-icon [icon]="faInbox" class="fs-5"></fa-icon>
                  <p class="m-0">No Peerings Found</p>
                </div>
              </div>

            </div>

            <!-- Private Links Tab Content -->
            <div class="tab-pane fade" id="private-links" role="tabpanel" aria-labelledby="private-links-tab">
              <h3 class="mt-3">Private Links Table</h3>
            </div>

          </div>

        </div>

      </div>

    </div>
    </div>

</app-content-body>


<div class="d-flex flex-row border-top p-3 fixed-bottom back-btn-parent">
  <button
  class="btn px-3 me-3 btn-sm submit btn-primary btn-width"
  (click)="navigateToDashboard()"
  >
    Back
  </button>
</div>

<ng-template #viewServerDetailsModal let-modal>
  <div class="modal-header px-4">
    <p class="fs-6 m-0 modal-title fw-bold">View Server Details</p>
  </div>
  <div class="modal-body pb-2 view-details-body">
    <div class="d-flex flex-row g-2 details">
      <div class="col-6 br-1">
        <div class="row">
          <div class="col-12">
            <b>Name</b>
          </div>
          <div class="col-12">
            <p>{{ serverToView?.name ?? "" }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <b>Profile</b>
          </div>
          <div class="col-12">
            <p>{{ serverToView?.profile ?? "" }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <b>VNET</b>
          </div>
          <div class="col-12">
            <p>{{ serverToView?.vnet ?? "" }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <b>Public IP</b>
          </div>
          <div class="col-12">
            <p>{{ serverToView?.publicIp ?? "" }}</p>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="row">
          <div class="col-12">
            <b>Type</b>
          </div>
          <div class="col-12">
            <p>{{ serverToView?.type ?? "" }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <b>Region</b>
          </div>
          <div class="col-12">
            <p>{{ serverToView?.region ?? "" }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <b>Subnet</b>
          </div>
          <div class="col-12">
            <p>{{ serverToView?.subnet ?? "" }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <b>Private IP</b>
          </div>
          <div class="col-12">
            <p>{{ serverToView?.privateIp ?? "" }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-sm btn-outline-primary"
      (click)="modal.close('Ok Naughty Boy')"
    >
      Close
    </button>
  </div>
</ng-template>

<ng-template #connectionDetailsModal let-modal>
  <div class="modal-header">
    <h2 class="modal-title">Connection details</h2>
  </div>

  <div class="modal-body px-5">
    <!-- Windows Server Info Section -->
    <div class="row" *ngIf="true">
      <div class="col-md-4 col-12">
        <b>Public IP</b>
        <p class="mt-2">Ok</p>
      </div>

      <div class="col-md-4 col-12">
        <b>User Name</b>
        <p class="mt-2">abc</p>
      </div>

      <div class="col-md-4 col-12">
        <b>Password</b>
        <div class="d-flex align-items-center mt-2">
          <p class="mb-0">***********</p>
          <i
            class="fa fa-copy ms-2"
            style="cursor: pointer"
            data-toggle="tooltip"
          >
          </i>
        </div>
      </div>

      <div class="col-12 mt-3 mb-3">
        <a href="#" class="card-link">Go to NCache Management Center</a>
      </div>
    </div>

    <!-- Linux Server Info Section -->
    <!-- <div class="row" *ngIf="!isWindowsOS">
            <div class="col-12">
                <b>Public IP</b>
                <p class="mt-2">{{linuxServerInfo?.publicIP}}</p>
            </div>

            <div class="col-12">
                <b>SSH Command to Connect</b>
                <div class="code d-flex justify-content-between align-items-center px-3 py-2 mt-2">
                    <p class="mb-0">{{linuxServerInfo?.sshKey}}</p>
                    <button (click)="copyPassword(linuxServerInfo?.sshKey)" type="button"
                        class="btn btn-sm code-btn btn-primary">
                        {{ isCopied ? 'Copied' : 'Copy' }}
                    </button>
                </div>
            </div>

            <div class="col-12 mt-3 mb-3">
                <a href="#" class="card-link" (click)="goToWebManager($event)">Go to NCache Management Center</a>
            </div>
        </div> -->
  </div>

  <div class="modal-footer d-flex justify-content-end">
    <button type="button" class="btn btn-primary btn-sm" *ngIf="true">
      Download RDP File
    </button>
    <button
      type="button"
      class="btn btn-outline-primary btn-sm ms-2"
      (click)="modal.close()"
    >
      Close
    </button>
  </div>
</ng-template>

<ng-template #deletePeeringModal let-modal>

  <form (ngSubmit)="this.deletePeering()">

    <div class="modal-header px-2">
      <h5 class="modal-title" id="confirm-delete-peering-modal"> <b>Delete Peering</b> </h5>
    </div>

    <div class="modal-body px-4 mb-2">

      <p class="m-0">Are you sure that you want to delete this peering connection? {{this.selectedPeeringId}}</p>

      <div class="mb-2 mt-3">

        <label for="deletePeering" class="col-form-label">To confirm deletion, type delete in the field</label>

        <input
          id="deletePeering"
          class="form-control form-control-sm flex-grow-1 border border-2"
          type="text"
          placeholder="delete"
          [(ngModel)]="this.deletePeeringInput"
          (ngModelChange)="this.onPeeringInputChange()"
          [readOnly]="this.isDeletingPeering"
        />

      </div>

    </div>

    <div class="d-grid gap-2 d-md-flex justify-content-md-end pb-4 px-4">

      <button class="btn btn-sm btn-outline-primary me-md-2" type="button" (click)="this.dismiss()" [disabled]="this.isDeletingPeering">Cancel</button>

      <button type="submit" class="btn btn-sm btn-danger" [disabled]="this.isPeeringDeletionDisabled || this.isDeletingPeering">
        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" *ngIf="this.isDeletingPeering"></span>
        Delete
      </button>

    </div>

  </form>

</ng-template>

<ng-template #configureAllowedIPsModal let-modal>

  <form [formGroup]="allowedIPsFormGroup" (ngSubmit)="addAllowedIPs()">

    <div class="modal-header px-2">
      <h5 class="modal-title" id="confirm-delete-peering-modal"> <b>Edit Whitelisted IP Addresses</b> </h5>
    </div>

    <div class="modal-body px-4 mb-2">

      <p class="m-0">Specify the IP addresses that are allowed to connect to the cache servers. Enter IPs to whitelist, separated by commas. Only traffic from these addresses will be allowed.</p>

      <div class="mb-2 mt-3">

        <label for="public-ips" class="form-label fw-bold">IP Addresses<span class="text-danger ms-1 me-2">*</span>
          <span style="cursor: pointer;" data-bs-toggle="tooltip" data-bs-placement="top" title="Provide an IP address (e.g., 192.168.99.0). You can also provide a list of multiple IPs using IPv4. Only traffic from these addresses will be allowed.">
            <i class="fas fa-question-circle" style="cursor: pointer;" ></i>
          </span>
        </label>

        <div class="mx-2">
          <div class="form-check mt-2 form-check-inline">
            <input [checked]="!selectivePublicIps" class="form-check-input" type="radio" name="inlineRadioOptions" id="allowedAllIpsRadio" value="all" (change)="onAllowedIpsRadioChange($event.target.value)">
            <label class="form-check-label" for="publicIpRadio">All</label>
          </div>
          <div class="form-check mt-2 form-check-inline">
            <input [checked]="selectivePublicIps" class="form-check-input" type="radio" name="inlineRadioOptions" id="allowedSelectiveIpsRadio" value="selective" (change)="onAllowedIpsRadioChange($event.target.value)">
            <label class="form-check-label" for="peeringRadio">Selective</label>
          </div>
        </div>

        <div class="input-group mb-1" *ngIf="selectivePublicIps">

          <input
            (blur)="onSaveAllowedIPs()"
            [ngClass]="{ 'is-invalid': isAllowedIPsSubmitted && allowedIPsForm?.allowedIPs.invalid }"
            type="text"
            class="form-control form-control-sm"
            formControlName="allowedIPs"
            placeholder="Enter IPs, separated by commas. e.g. 192.168.1.1, 192.168.1.2"
            [readonly]="isAddingAllowedIPs"
          />

          <!-- <button
            [disabled]="isAddingAllowedIPs"
            class="btn btn-primary btn-sm px-4"
            type="submit"
            id="ips-btn">
            Add
          </button> -->

        </div>

        <div class="text-danger mt-1" *ngIf="isAllowedIPsSubmitted && allowedIPsForm?.allowedIPs?.errors?.required">
          IP address is required.
        </div>

        <div class="text-danger mt-1" *ngIf="isAllowedIPsSubmitted && !allowedIPsForm?.allowedIPs?.errors?.required && allowedIPsForm?.allowedIPs?.errors?.whitespace">
          IP address cannot be empty.
        </div>

        <div class="text-danger mt-1" *ngIf="isAllowedIPsSubmitted && allowedIPsForm?.allowedIPs?.errors?.invalidIPs">
            <span>{{ invalidIPsErr[0] }}</span>
        </div>

        <div class="mt-2" *ngIf="!selectivePublicIps">
          <p style="color: #ff9500">WARNING: "All" will expose your servers to unauthorized users.</p>
        </div>

        <!-- <div *ngIf="!isLoadingAllowedIPs && allowedIPs.length > 0">
          <ul class="list-group mt-4 ips-list">
            <li *ngFor="let ip of allowedIPs" class="d-flex justify-content-between align-items-center list-group-item list-group-item-secondary">
              <p class="font-weight-bold my-auto">{{ ip }}</p>
              <span class="text-danger" (click)="!isAddingAllowedIPs && deleteIP(ip)" [ngClass]="{'cursor-default': isAddingAllowedIPs, 'cursor-pointer': !isAddingAllowedIPs}">
                 <fa-icon [icon]="faTrash" style="font-size: 16px;"></fa-icon>
              </span>
            </li>
          </ul>
        </div> -->

        <!-- <div *ngIf="!isLoadingAllowedIPs && allowedIPs.length === 0" class="mt-4">
          <ul class="list-group ips-list">
            <li class="d-flex justify-content-center align-items-center list-group-item list-group-item-secondary">
              <p style="padding: 0; margin: 0;" class="text-center">Nothing found</p>
            </li>
          </ul>
        </div>

        <ng-template *ngIf="isLoadingAllowedIPs">
          <div class="spinner-border text-primary" role="status" style="width: 1.5rem; height: 1.5rem; margin-top: 10px;">
            <span class="visually-hidden">Loading...</span>
          </div>
        </ng-template> -->


      </div>

    </div>

    <div class="d-grid gap-2 d-md-flex justify-content-md-end pb-4 px-4 modal-footer">

      <button class="btn btn-sm btn-primary px-3 me-2" type="submit" [disabled]="isAddingAllowedIPs" >
        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" *ngIf="isAddingAllowedIPs"></span>
        Update
      </button>

      <button class="btn btn-sm btn-outline-primary px-3" type="button" (click)="this.dismiss()" [disabled]="this.isDeletingPeering">Cancel</button>

    </div>

  </form>

</ng-template>

<ng-template #clientPeeringDeleteModal let-modal>

    <div class="modal-header px-2">
      <h5 class="modal-title" id="confirm-delete-peering-modal"> <b> Remove Peering Connection from Azure Portal</b> </h5>
    </div>

    <div class="modal-body px-4 mb-2">

      <p>Please remove the peering connection having name <b>{{azClientPeeringConnectionName || ''}}</b> from your Azure Portal since its current state is now <b>Disconnected</b>.</p>

      <p class="mb-0"><b>Failure to do so may:</b></p>

      <ul>
        <li class="mt-1">Prevent you from reconnecting this environment to your remote environment through peering.</li>
        <li class="mt-1">Lead to CIDR overlap issues.</li>
      </ul>

      <p class="mt-1">For step-by-step instructions, refer to the official documentation: <a [href]="azLinkDeletePeering" target="_blank">Remove Peering on Azure Portal</a></p>

    </div>

    <div class="modal-footer d-grid gap-2 d-md-flex justify-content-md-end pb-3 px-4">

        <button class="btn btn-sm btn-primary px-3" type="button" (click)="this.dismiss()">Close</button>

    </div>

</ng-template>

<ng-template #deleteServersModal let-modal>

  <form (ngSubmit)="this.removeVms()">

    <div class="modal-header px-2">
      <h5 class="modal-title" id="confirm-delete-server-modal"> <b>Delete Servers Confirmation</b> </h5>
    </div>

    <div class="modal-body px-4 mb-2">
      <p class="m-0">Are you sure you want to delete following server(s)?</p>

      <ul [ngClass]="{'delete-servers-modal':serversToDelete().length>=5 }">
        <li *ngFor="let server of serversToDelete()" class="fw-bold mt-2">{{server.name}}</li>
      </ul>

      <div class="mb-2 mt-3">

        <label for="deleteServers" class="col-form-label">Type 'delete' to delete server(s)</label>

        <input
          id="deleteServers"
          class="form-control form-control-sm flex-grow-1 border border-2"
          type="text"
          placeholder="delete"
          [(ngModel)]="this.deleteServersInput"
          autocomplete="off"
          (ngModelChange)="this.onDeleteServerInputChange()"
        />

      </div>

    </div>

    <div class="d-grid gap-2 d-md-flex justify-content-md-end pb-4 px-4">

      <button class="btn btn-sm btn-outline-primary me-md-2" type="button" (click)="this.dismiss()" >Cancel</button>

      <button type="submit" class="btn btn-sm btn-danger" [disabled]="!this.onDeleteServerInputChange()">
        <span class="me-1" role="status" aria-hidden="true"></span>
        Delete
      </button>

    </div>

  </form>

</ng-template>